export default [
    {
        label: "Cases",
        icon: "icon-briefcase",
        show:false, //whether to show this in the edit table 
        tableSettings: {
            route: "theCases",
            formType: "sidebarRightSide",
            showItemPerPageOption: false,
            showSelectTable: true,
            uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
            filter: {  //we filter the table based on this value. if don't want to have filter empty this
                pkId: "", 
                userLink: "", 
            },
            filterEndpoint: "carCases",
            showAddBtnDefault: false,
            showActionButtonDefault: false, //if this is false the add and edit button will not be shown 
            showEditBtnDefault: false,  
        },
    }, 
    {
        label: "Summons",
        icon: "icon-comman",
        show:false, //whether to show this in the edit table 
        tableSettings: {
            route: "summons",
            formType: "sidebarRightSide",
            showItemPerPageOption: false,
            showSelectTable: true,
            uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
            filter: {  //we filter the table based on this value. if don't want to have filter empty this
                pkId: "", 
                userLink: "", 
            },
            filterEndpoint: "carSummons",
            showAddBtnDefault: false,
            showActionButtonDefault: false, //if this is false the add and edit button will not be shown 
            showEditBtnDefault: false,  
        },
    }, 
    {
        label: "Work Order",
        icon: "icon-briefcase",
        show:false, //whether to show this in the edit table 
        tableSettings: {
            route: "theworkorders",
            formType: "sidebarRightSide",
            showItemPerPageOption: false,
            showSelectTable: true,
            uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
            filter: {  //we filter the table based on this value. if don't want to have filter empty this
                pkId: "",  
            },
            filterEndpoint: "carWorkOrder",
            showAddBtnDefault: false,
            showActionButtonDefault: false, //if this is false the add and edit button will not be shown 
            showEditBtnDefault: false,  
        },
    }, 
];